<template>
  <footer>
    <div class="container">
      <div class="row text-center">
        <div class="col-md-6">
          <p style="font-size: 24px; color: white; font-weight: bold">
            VueBlog
          </p>
          <!-- <p style="font-size: 24px; color: white; font-weight: bold">
            <i style="margin-right: 15px" class="fab fa-facebook-square"></i>
            <i style="margin-right: 15px" class="fab fa-instagram"></i>
            <i style="margin-right: 15px" class="fab fa-linkedin"></i>
            <i style="margin-right: 15px" class="fab fa-youtube"></i>
          </p> -->
        </div>
        <div class="col-md-6 pb-md-5">
          <p><router-link class="footer-links" to="/">Home</router-link></p>
          <p>
            <router-link class="footer-links" to="/blogs">Blogs</router-link>
          </p>
          <p v-if="!this.$store.state.isLoggedIn">
            <router-link class="footer-links" to="/login"
              >Login/Register</router-link
            >
          </p>
        </div>
      </div>
    </div>
    <div class="text-center" style="background-color: #2b2b2b">
      <p style="color: white; font-size: 14px" class="m-0">
        Copyright 2021 All Rights Reserved
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style>
footer {
  margin-top: auto;
  padding: 40px 0px 0px 0px;
  background-color: #303030;
}
.footer-links {
  color: White;
  text-decoration: none;
  font-size: 14px;
}
.footer-links:hover {
  color: #ddd;
}
</style>